import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QualRoutingModule } from './qual-routing.module';
import { QualComponent } from './qual.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { SharedRepositoryModule } from '../shared-repository/shared-repository.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { InterviewInviteComponent } from './interview-invite/interview-invite.component';


@NgModule({
  declarations: [
    QualComponent,
    InterviewInviteComponent
  ],
  imports: [
    CommonModule,
    QualRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    SharedRepositoryModule,
    InfiniteScrollModule
  ],
  exports: [
    InterviewInviteComponent
  ]
})
export class QualModule { }
